import { Component, type ReactNode } from 'react';
import { setAsideSession } from '../state/store';

interface State {
  failed: boolean;
}

/**
 * If a screen fails to draw, the learner gets a way back instead of a blank page. Their progress
 * is kept; only today's unfinished session is set aside, and the next start plans afresh.
 */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  state: State = { failed: false };

  static getDerivedStateFromError(): State {
    return { failed: true };
  }

  private recover = async () => {
    try {
      await setAsideSession();
    } catch {
      // Nothing more to do: the reload below starts clean.
    }
    window.location.hash = '#/';
    window.location.reload();
  };

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main className="page" role="alert">
        <h1 className="title">Something went wrong</h1>
        <p className="subtitle">Your progress is safe. Going back to Today sets aside the current session and plans a fresh one.</p>
        <button type="button" className="btn btn-primary btn-lg" onClick={this.recover}>
          Back to Today
        </button>
      </main>
    );
  }
}
